import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HtmlParser from "react-html-parser";

const StackItem = [
  {
    icon: "01",
    title: "Data-Driven<br/> Marketing Excellence",
    description:
      "We leverage advanced analytics to craft strategies focused on optimizing ROI and performance metrics.",
  },
  {
    icon: "02",
    title: "Industry-Leading<br/> Experts",
    description:
      "Our specialists bring deep technical expertise across digital marketing for top-tier campaign execution.",
  },
  {
    icon: "03",
    title: "Customized Digital<br/> Frameworks",
    description:
      "We design bespoke digital frameworks that precisely align with your objectives and drive targeted, scalable results.",
  },
];

function Purposeweb() {
  return (
    <div className="technoloy_sec digital_why_choose p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Why Choose <span>TekRevol</span> as Your Digital Marketing Company
            </h2>
            <p>
              TekRevol offers top-tier digital marketing services known for
              delivering actionable, results-oriented solutions tailored to your
              unique business needs. Our focus is on driving measurable growth,
              optimizing your digital footprint, and ensuring sustained success
              across all digital channels.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="m-auto">
            <div className="technology_main web_purpose_text">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon web_text">{item.icon}</div>
                  <h6>{HtmlParser(item.title)}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Purposeweb;
